import React from 'react';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import FlatButton from 'material-ui/FlatButton';

import Dialog from 'material-ui/Dialog';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class NavBar extends React.Component{

  state = {
   open: false,
 };

 handleOpen = () => {
   this.setState({open: true});
 };

 handleClose = () => {
   this.setState({open: false});
 };

render (){

  const flat = {
    color: 'white',
    fontSize: 12
  };

  const raisedButtonStyle = {
    margin: 12,
  };

  const logo = {

    color: 'white'

  };

  const styles = {
    title: {
      cursor: 'pointer',
    },
  };

  return (
  <MuiThemeProvider>
  <AppBar
    style= {{backgroundColor: 'black'}}
    title={<Link style = {{color: 'black'}} to = "/"> <span style={logo}>STREAMLINE MCAT</span> </Link>}
    iconElementRight={<div>
    <Link style = {{color: 'black'}} to = "/"> <FlatButton><span style = {flat}>Home</span></FlatButton> </Link>
    <Link style = {{color: 'black'}} to = "/physics"> <FlatButton><span style = {flat}>Physics</span></FlatButton> </Link>
    <FlatButton onClick={this.handleOpen} > <span style = {flat}>About</span></FlatButton>
    </div>} />

  <Dialog
         title="STREAMLINE MCAT"
         actions=  {<FlatButton
        label="OK"
        primary={true}
        onClick={this.handleClose}
      />}
         modal={false}
         open={this.state.open}
         onRequestClose={this.handleClose}
       >
         The website contains high yield information that needs to be memorized for the MCAT. It doesn't contain everything you need to know for the MCAT.
         Please tell us any high yield material that must be on the site. <br/> <br/> Email: streamlinemcat@gmail.com

       </Dialog>

  </MuiThemeProvider>
);

}


}

export default NavBar;



// WEBPACK FOOTER //
// ./src/navBar/NavBar.js